import ProductHelper from '@/services/API/helpers/ProductHelper'

const calcTotal = ProductHelper.calcTotal

const setCartItems = function(
    { commit, rootGetters, state, rootState },
    items
) {
    const activeTransaction = rootGetters['TransactionModule/activeTransaction']
    try {
        items = ProductHelper.frontendProductsArray(items, activeTransaction.id)
    } catch (e) {
        throw e
    }
    commit('SET_ITEMS', JSON.parse(JSON.stringify(items)))
    let total = calcTotal(items, state.globalDiscount)
    if ([2, 3].includes(activeTransaction.id)) {
        const neto = total
        const iva = ProductHelper.truncateAndRound(neto * 0.19)
        total = neto + iva
        commit('SET_NETO_AND_IVA', { neto, iva })
    } else {
        commit('SET_NETO_AND_IVA', { neto: 0, iva: 0 })
    }
    commit('SET_TOTAL', total)
}

const refreshItems = ({ dispatch, state }) => {
    dispatch('setCartItems', state.items)
}

const addItemToCart = function({ commit }, item) {
    //helpers.addSaleProperties(item)
    commit('ADD_ITEM', item)
}

const setGlobalDiscount = function({ commit, rootGetters, state }, discount) {
    commit('SET_GLOBAL_DISCOUNT', discount)
    const activeTransaction = rootGetters['TransactionModule/activeTransaction']
    let total = calcTotal(state.items, state.globalDiscount)
    if ([2, 3].includes(activeTransaction.id)) {
        const neto = total
        const iva = ProductHelper.truncateAndRound(neto * 0.19)
        total = neto + iva
        commit('SET_NETO_AND_IVA', { neto, iva })
    } else {
        commit('SET_NETO_AND_IVA', { neto: 0, iva: 0 })
    }
    commit('SET_TOTAL', total)
}

const setActiveMobileItemId = ({ commit }, id) =>
    commit('SET_ACTIVE_MOBILE_ITEM_ID', id)

const resetState = function({ commit }) {
    commit('RESET_STATE')
}

export default {
    setCartItems,
    addItemToCart,
    resetState,
    setGlobalDiscount,
    refreshItems,
    setActiveMobileItemId,
}
